export default "/_next/static/bb1a6463eafd698e26decc606dea623f.png";